import React, { PureComponent, Fragment } from 'react';
import AppBar from '@material-ui/core/AppBar';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Drawer from '@material-ui/core/Drawer';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
//icons
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NotesIcon from '@material-ui/icons/Notes';
import MenuIcon from '@material-ui/icons/Menu';
import Logo from '../../assets/jg.png'
import Footer from './Footer/Footer'
import { LanguageContext } from '../../context/lang'
export const styles = theme => ({
  mobileButtonSlider:{
    display: 'inline-flex',
    [theme.breakpoints.up('sm')]: {
        display: 'none',
    }
  },
  DesktopLinks:{
    display: 'none',
    [theme.breakpoints.up('sm')]: {
        display: 'block',
    }
  },
  imgResponsive: {
    [theme.breakpoints.down('md')]: {
        width: 40,
        height: 40
    }
  },
  /*toolbarCustom: {
    transition: 'all 150ms ease 0s',
    backgroundColor: 'transparent',
    color: 'white',
  },*/
  toolbarActive: {
    boxShadow: '0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(0, 188, 212, 0.46)',
    backgroundColor: '#00acc1'
  },
  drawerGrid: {
    width: 250,
  },
  footer: {
    height: "20vh",
  },
  footerLinks: {
    margin: "10px"
  },
  alignTitle:{
    flexGrow: 1,
    textAlign: "center"
  },
  button: {
    fontFamily: '"Poiret One", Helvetica, sans-serif',
    color: 'white',
    margin: theme.spacing.unit,
  },
  footerIcons: {
    height: '1.7em',
    margin: '5px'
  },
  footerIconColor: {
    fill: 'white'
  },
  alignLang: {
    position: 'absolute',
    right: '25px'
  },
  displayInlineflex: {
    display: 'inline-flex'
  },
  verticalAlign: {
    verticalAlign: 'middle'
  }
});
export const Layout = (WrappedComponent) => {
    return class extends PureComponent {
        constructor() {
            super();
            this.state = {
                isOpen: false,
                openLogin: false,
                shouldShow: false,
                lastScroll: null,
            };
            this.headerRef = React.createRef();
        }

        toggleDrawer = (open) => () => {
            this.setState({
                isOpen: open
            });
        };
        handleOpen = ()=> {
            this.setState({ openLogin: true });
        }
        handleClose = () => {
            this.setState({ openLogin: false });
        };
        closeDialog = () => () => {
            this.setState({
                openLogin: false
            });
        };
        render() {  
            const { classes } = this.props;
            
            const drawerOptions = () => (     
                <div style={{width: "100%"}}>
                    <List style={{padding: 0}} component="nav">
                        <Grid
                            container
                            direction="row"
                            justify="flex-start"
                            alignItems="flex-start"
                            style={{margin: '5px 0', padding: '0 15px'}}
                        >   
                            <IconButton style={{alignSelf: 'center', marginRight: 40}} onClick={this.toggleDrawer(false)}>
                                <ChevronLeftIcon /> 
                            </IconButton>
                            <div style={{
                                    display: 'inline-flex',
                                    flexGrow: 1,
                                    alignSelf: 'center'
                                }}
                            >
                                <img src={Logo} className={classes.imgResponsive} alt="JG" height="50" width="50"/>
                            </div>
                        </Grid>
                        <Divider />
                        <ListItem button onClick={() =>{this.props.history.push('/')}}>
                            <ListItemIcon>
                                <NotesIcon />
                            </ListItemIcon>
                            <ListItemText primary="Home" />
                        </ListItem > 
                        <ListItem button onClick={() =>{this.props.history.push('/project')}}>
                            <ListItemIcon>
                                <NotesIcon />
                            </ListItemIcon>
                            <ListItemText primary="Project" />
                        </ListItem > 
                        <ListItem button onClick={() =>{this.props.history.push('/experience')}}>
                            <ListItemIcon>
                                <NotesIcon />
                            </ListItemIcon>
                            <ListItemText primary="Experience" />
                        </ListItem > 
                        <ListItem button onClick={() =>{this.props.history.push('/contact')}}>
                            <ListItemIcon>
                                <NotesIcon />
                            </ListItemIcon>
                            <ListItemText primary="Contact" />
                        </ListItem >                     
                    </List>
                </div>
            );      
        
            const appBarLinks = () => (
            
                <LanguageContext.Consumer>
                {({changeLanguage}) =>(
                <Fragment>
                <div className={[classes.alignTitle, classes.DesktopLinks].join(" ")} >
                    <Button className={classes.button} onClick={() =>{this.props.history.push('/')}}>
                        Home
                    </Button>
                    <Button className={classes.button} onClick={() =>{this.props.history.push('/project')}}>
                        Project
                    </Button>
                    <div className={[classes.verticalAlign, classes.displayInlineflex].join(" ")}><span><img src={Logo} className={classes.imgResponsive} alt="JG" height="50" width="50"/></span></div>

                    <Button className={classes.button} onClick={() =>{this.props.history.push('/experience')}}>
                        Experience
                    </Button>
                    <Button className={classes.button} onClick={() =>{this.props.history.push('/contact')}}>
                        Contact
                    </Button>
                </div>
                <div className={classes.alignLang}>
                    <div style={{display: "inline-flex"}} onClick={changeLanguage}>
                        <svg className={classes.footerIcons} role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path  className={classes.footerIconColor} d="M 20.480469 3.519531 C 18.253906 1.292969 15.304688 0.0507812 12.164062 0.0078125 C 12.109375 0.00390625 12.054688 0 12 0 C 11.945312 0 11.890625 0.00390625 11.835938 0.0078125 C 8.695312 0.0507812 5.746094 1.292969 3.519531 3.519531 C 1.253906 5.785156 0.0078125 8.796875 0.0078125 12 C 0.0078125 15.203125 1.253906 18.214844 3.519531 20.480469 C 5.746094 22.707031 8.695312 23.949219 11.835938 23.992188 C 11.890625 23.996094 11.945312 24 12 24 C 12.054688 24 12.109375 23.996094 12.164062 23.992188 C 15.304688 23.949219 18.253906 22.707031 20.480469 20.480469 C 22.746094 18.214844 23.992188 15.203125 23.992188 12 C 23.992188 8.796875 22.746094 5.785156 20.480469 3.519531 Z M 4.527344 4.527344 C 5.800781 3.253906 7.34375 2.34375 9.027344 1.855469 C 8.648438 2.292969 8.277344 2.792969 7.9375 3.351562 C 7.496094 4.058594 7.117188 4.828125 6.800781 5.644531 L 3.554688 5.644531 C 3.851562 5.253906 4.175781 4.878906 4.527344 4.527344 Z M 2.648438 7.070312 L 6.320312 7.070312 C 5.941406 8.40625 5.714844 9.832031 5.65625 11.285156 L 1.457031 11.285156 C 1.554688 9.796875 1.960938 8.367188 2.648438 7.070312 Z M 2.648438 16.929688 C 1.960938 15.632812 1.554688 14.203125 1.457031 12.714844 L 5.65625 12.714844 C 5.714844 14.167969 5.9375 15.59375 6.320312 16.929688 Z M 4.527344 19.472656 C 4.175781 19.121094 3.851562 18.746094 3.554688 18.355469 L 6.800781 18.355469 C 7.117188 19.171875 7.496094 19.941406 7.9375 20.648438 C 8.277344 21.207031 8.648438 21.707031 9.027344 22.144531 C 7.34375 21.65625 5.800781 20.746094 4.527344 19.472656 Z M 11.285156 22.28125 C 10.691406 21.890625 9.894531 21.113281 9.148438 19.902344 C 8.851562 19.414062 8.582031 18.898438 8.34375 18.355469 L 11.285156 18.355469 Z M 11.285156 16.929688 L 7.808594 16.929688 C 7.390625 15.609375 7.144531 14.179688 7.085938 12.714844 L 11.285156 12.714844 Z M 11.285156 11.285156 L 7.085938 11.285156 C 7.144531 9.820312 7.390625 8.390625 7.808594 7.070312 L 11.285156 7.070312 Z M 11.285156 5.644531 L 8.34375 5.644531 C 8.582031 5.101562 8.851562 4.585938 9.148438 4.097656 C 9.894531 2.886719 10.691406 2.109375 11.285156 1.71875 Z M 21.351562 7.070312 C 22.039062 8.367188 22.445312 9.796875 22.542969 11.285156 L 18.34375 11.285156 C 18.285156 9.832031 18.058594 8.40625 17.679688 7.070312 Z M 19.472656 4.527344 C 19.824219 4.878906 20.148438 5.253906 20.445312 5.644531 L 17.199219 5.644531 C 16.882812 4.828125 16.503906 4.058594 16.0625 3.351562 C 15.722656 2.792969 15.351562 2.292969 14.972656 1.855469 C 16.65625 2.34375 18.199219 3.253906 19.472656 4.527344 Z M 12.714844 1.71875 C 13.308594 2.109375 14.105469 2.886719 14.851562 4.097656 C 15.148438 4.585938 15.417969 5.101562 15.65625 5.644531 L 12.714844 5.644531 Z M 12.714844 7.070312 L 16.191406 7.070312 C 16.609375 8.390625 16.855469 9.820312 16.914062 11.285156 L 12.714844 11.285156 Z M 16.914062 12.714844 C 16.855469 14.179688 16.609375 15.609375 16.191406 16.929688 L 12.710938 16.929688 L 12.710938 12.714844 Z M 12.714844 22.28125 L 12.714844 18.355469 L 15.65625 18.355469 C 15.417969 18.898438 15.148438 19.414062 14.851562 19.902344 C 14.105469 21.113281 13.308594 21.890625 12.714844 22.28125 Z M 19.472656 19.472656 C 18.199219 20.746094 16.65625 21.65625 14.972656 22.144531 C 15.351562 21.707031 15.722656 21.207031 16.0625 20.648438 C 16.503906 19.941406 16.882812 19.171875 17.199219 18.355469 L 20.445312 18.355469 C 20.148438 18.746094 19.824219 19.121094 19.472656 19.472656 Z M 21.351562 16.929688 L 17.679688 16.929688 C 18.058594 15.59375 18.285156 14.167969 18.34375 12.714844 L 22.542969 12.714844 C 22.445312 14.203125 22.039062 15.632812 21.351562 16.929688 Z M 21.351562 16.929688 "/></svg>                    
                    </div> 
                </div>
                </Fragment>
                )}
                </LanguageContext.Consumer>
            )
            return (    
                <Fragment>
                    <AppBar
                        position="fixed" 
                        className={[classes.toolbarCustom, (this.state.shouldShow?classes.toolbarActive: null)].join(" ") }
                        ref={this.headerRef}
                    >
                        <Toolbar>
                            <IconButton className={classes.mobileButtonSlider} onClick={this.toggleDrawer(true)} color="inherit" aria-label="Menu">
                                <MenuIcon />
                            </IconButton> 
                            <Typography 
                                variant="title" 
                                color="inherit" 
                            >
                            </Typography>   
                            
                            { appBarLinks() }                        
                        </Toolbar>
                    <Drawer 
                        open={this.state.isOpen} 
                        onClose={this.toggleDrawer(false)}
                    >
                        <Grid
                        container
                        direction="column"
                        justify="flex-start"
                        alignItems="flex-start"
                        className={classes.drawerGrid}
                        >   
                            { drawerOptions() }   
                        </Grid>
                    </Drawer>
                    </AppBar>
                        <WrappedComponent />
                    <Footer/>
                </Fragment>     
            )
        }    
    };
}
export default (cmp) => withStyles(styles)(Layout(cmp));